import { Leaf, ArrowUpRight, Instagram, Linkedin, MessageCircle } from 'lucide-react';

export const LandingFooter = () => {
  return (
    <footer className="bg-[#0a2e1f] text-white pt-24 pb-12 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-24 mb-24">

          {/* Logo & Description */}
          <div className="col-span-1 lg:col-span-2">
            <div className="mb-12">
              <img
                src="https://locaninja.com/logotipo-watch.png"
                alt="Watch Smart Media Logo"
                className="h-12 lg:h-16 w-auto block object-contain"
                style={{ minWidth: '140px' }}
              />
            </div>
            <p className="text-gray-300 text-xl lg:text-3xl font-medium max-w-lg mb-12 leading-tight">
              A revolução visual que o seu negócio precisa.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center hover:bg-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-6 h-6" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center hover:bg-primary transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-6 h-6" />
              </a>
              <a
                href="https://wa.me/5548999999999"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center hover:bg-primary transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-black text-xs uppercase tracking-[0.3em] mb-10 text-primary">Produto</h4>
            <ul className="space-y-6 font-black text-lg text-gray-400">
              <li>
                <a href="#features" className="hover:text-white flex items-center gap-2 group transition-colors">
                  Recursos <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-all" />
                </a>
              </li>
              <li>
                <a href="/auth" className="hover:text-white flex items-center gap-2 group transition-colors">
                  Planos PRO <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-all" />
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="hover:text-white flex items-center gap-2 group transition-colors">
                  Instalação <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-all" />
                </a>
              </li>
              <li>
                <a href="mailto:suporte@letswatch.com.br" className="hover:text-white flex items-center gap-2 group transition-colors">
                  Central de Ajuda <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-all" />
                </a>
              </li>
            </ul>
          </div>

          {/* Sustainability */}
          <div className="flex flex-col justify-between">
            <div>
              <h4 className="font-black text-xs uppercase tracking-[0.3em] mb-10 text-primary">Sustentabilidade</h4>
              <div className="bg-[#0e3d29] p-8 rounded-[32px] border border-white/5">
                <div className="flex items-center gap-3 mb-4">
                  <Leaf className="text-primary w-8 h-8" />
                  <span className="font-black text-white text-lg">Clean Media Tech</span>
                </div>
                <p className="text-gray-400 text-sm font-medium">
                  Reduza o desperdício de papel e cartazes plásticos em 100%.
                </p>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-12 border-t border-white/10 flex flex-col gap-8 text-[10px] lg:text-xs font-black uppercase tracking-[0.4em] text-gray-500">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-8 w-full">
            <p>© 2026 Watch Technologies | Watch Station Development Suite</p>
            <div className="flex gap-10">
              <a href="#" className="hover:text-white transition-colors">Privacidade</a>
              <a href="#" className="hover:text-white transition-colors">Termos</a>
              <a href="#" className="hover:text-white transition-colors">Cookies</a>
            </div>
          </div>

          <div className="flex justify-center items-center w-full">
            <p className="flex items-center gap-2">
              Feito com <span className="text-red-500 text-base">♥</span> em Palhoça & Florianópolis | SC.
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
};
